import React, { useState } from "react";
import axios from "axios";

export default function Contact() {
  const [pageData, setPageData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    number: "",
    message: "",
  });

  const onchange = (e) => {
    const { name, value } = e.target;

    setPageData((prevState) => ({ ...prevState, [name]: value }));
  };

  const onSubmit = (e) => {
    const formError = document.getElementById("form-error");
    const formSuccess = document.getElementById("form-success");
    const formContainer = document.getElementById("wf-form-Contact-Form");

    for (const property in pageData) {
      if (pageData[property] === "") {
        return (formError.style.display = "block");
      }
    }

    axios
      .post("https://sahabt-mail.herokuapp.com/sendMail", {
        text: `${pageData.firstName} ${pageData.lastName} ${pageData.email} ${pageData.number} ${pageData.message}`,
      })
      .then((res) => {
        if (res.data.isSuccess) {
          e.preventDefault();
          if (formError.style.display === "block") {
            formError.style.display = "none";
          }
          formContainer.style.display = "none";
          formSuccess.style.display = "block";
        }
      });
  };

  return (
    <div>
      <div className="wrapper">
        <div className="section large wf-section">
          <div className="container">
            <div className="spacer _32" />
            <div className="w-layout-grid _2-grid">
              <img
                src="https://uploads-ssl.webflow.com/61e916f8909f787dbfdb155a/61e916f8909f780121db1575_iPad%20Pro%2014.svg"
                loading="lazy"
                width={401}
                id="w-node-_4eadc708-f91c-0e51-116c-ffcdd56f3681-16db158b"
                alt="Avatar Squad NFT Website Template Asset"
                className="center-image mobile-small"
              />
              <div className="text-box _550px centered">
                <h1 className="heading h2">Bizimle iletişime geçiniz.</h1>
                <p>
                  Bizimle iletişime geçiniz hazır formu doldurarak sizinle
                  iletişime geçmemizi bekleyiniz.
                </p>
                <div className="spacer _32" />
                <div className="w-form">
                  <div
                    id="wf-form-Contact-Form"
                    name="wf-form-Contact-Form"
                    data-name="Contact Form"
                    // method="post"
                    className="form">
                    <div className="field-split">
                      <div className="field-block">
                        <label htmlFor="First-Name">Adınız*</label>
                        <input
                          type="text"
                          className="text-input w-input"
                          maxLength={256}
                          name="firstName"
                          data-name="First Name"
                          placeholder="Adınız"
                          id="First-Name"
                          required
                          onChange={onchange}
                        />
                      </div>
                      <div className="field-spacer" />
                      <div className="field-block">
                        <label htmlFor="Last-Name">Soyadınız*</label>
                        <input
                          type="text"
                          className="text-input w-input"
                          maxLength={256}
                          name="lastName"
                          data-name="Last Name"
                          placeholder="Soyadınız"
                          id="Last-Name"
                          required
                          onChange={onchange}
                        />
                      </div>
                    </div>
                    <div className="field-split">
                      <div className="field-block">
                        <label htmlFor="Email">Email*</label>
                        <input
                          type="email"
                          className="text-input w-input"
                          maxLength={256}
                          name="email"
                          data-name="email"
                          placeholder="deneme@email.com"
                          id="Email"
                          required
                          onChange={onchange}
                        />
                      </div>
                      <div className="field-spacer" />
                      <div className="field-block">
                        <label htmlFor="number">Telefon Numaranız*</label>
                        <input
                          type="tel"
                          className="text-input w-input"
                          maxLength={256}
                          name="number"
                          data-name="phoneNumber"
                          placeholder="216 504 56 55"
                          id="field"
                          required
                          onChange={onchange}
                        />
                      </div>
                    </div>
                    <div className="field-block">
                      <label htmlFor="Message">Mesajınız*</label>
                      <textarea
                        placeholder="Mesajınızı giriniz"
                        maxLength={5000}
                        data-name="Message"
                        name="message"
                        id="Message"
                        className="text-area w-input"
                        defaultValue={""}
                        onChange={onchange}
                      />
                    </div>
                    <button
                      defaultValue="Send Message"
                      data-wait="Lütfen Bekleyiniz..."
                      className="button no-margin w-button"
                      onClick={onSubmit}>
                      Gönder
                    </button>
                  </div>
                  <div className="form-success w-form-done" id="form-success">
                    <div>
                      Talebiniz gönderildi ve kısa süre içinde size ulaşacağız.
                    </div>
                  </div>
                  <div className="form-error w-form-fail" id="form-error">
                    <div>
                      Hata! Bir şeyler yanlış gitti. Lütfen gerekli alanları
                      doldurun ve tekrar deneyin.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
